import React from 'react';
import { Box } from '@mui/material';
import { RiseLoader } from 'react-spinners';
import './common.scss';

const PageLoader = ({ color = "#39ff14", loading = true }) => {
    if (!loading) return null;

    return (
        <Box className="page-loader">
            <RiseLoader color={color} size={15} margin={2} />
        </Box>
    );
};

export default PageLoader;
